import { useEffect, useRef } from "react";

export default function Cursor() {
  const dot = useRef(null);

  useEffect(() => {
    const el = dot.current;
    if (!el) return;
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tx = x;
    let ty = y;
    let raf;

    const move = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };
    const over = (e) => {
      const t = e.target;
      if (t.closest("a, button, [role='button'], input, textarea, select, .cursor-hover")) {
        el.classList.add("is-hover");
      } else {
        el.classList.remove("is-hover");
      }
    };
    const loop = () => {
      x += (tx - x) * 0.2;
      y += (ty - y) * 0.2;
      el.style.left = `${x}px`;
      el.style.top = `${y}px`;
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={dot} className="cursor-dot" aria-hidden="true" />;
}
